export type Zipcode = string;

export interface City {
  name: string;
  zipcodes: Zipcode[];
}

export interface County {
  name: string;
  cities: City[];
}

export interface Locations {
  counties: County[];
}

export interface ZipcodeOption {
  text: string;
  value: string;
  city: string;
  county: string;
}

export interface CityOption extends City {
  text: string;
  value: string;
  county: string;
}

export interface CountyOption extends County {
  text: string;
  value: string;
}

export function getCountyOptions(counties: County[]): CountyOption[] {
  return (
    counties
      ?.map(county => {
        return county?.name
          ? { ...county, text: county.name, value: county.name }
          : null;
      })
      .filter(Boolean) || []
  );
}

export function getCityOptions(input: CountyOption[] | County[]): CityOption[] {
  if (!input.length) {
    return [];
  }

  return (
    input
      .flatMap(
        county =>
          county?.cities?.map(city => ({
            ...city,
            county: county.name,
            text: city.name,
            value: city.name
          })) || []
      )
      .filter(Boolean) || []
  );
}

export function getZipcodeOptions(
  input: CityOption[] | County[]
): ZipcodeOption[] {
  if (!input.length) {
    return [];
  }

  let cityOptions: CityOption[];

  if (input[0] && typeof input[0] === 'object' && 'text' in input[0]) {
    cityOptions = input as CityOption[];
  } else {
    cityOptions = getCityOptions(input as County[]);
  }

  return (
    cityOptions
      ?.flatMap(
        city =>
          city?.zipcodes?.map(zipcode => ({
            text: zipcode,
            value: zipcode,
            county: city.county,
            city: city.name
          })) || []
      )
      .filter(Boolean) || []
  );
}
